import PropTypes from 'prop-types'
import React from 'react'
import clsx from 'clsx'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import searchModalDuck from 'components/search/search-section/duck'
import { openSearchResults } from 'components/search/utils'
import { withI18next } from 'lib/i18n/withI18next'
import { segmentSearchItemClicked } from 'lib/segment'
import { hasLocizeTranslation } from 'lib/utils/locize'
import Typo from 'constants/typography'

const getKeywordLocizeKey = (index) => `POPULAR_SEARCH_KEYWORD_${index + 1}`

const SearchSidebarItem = ({
  keywordList,
  isRecentSearchValid,
  openResults,
  setSearchWord,
  t,
}) => {
  const searchItem = (e) => {
    const innerText = e.currentTarget.textContent

    const searchClickedData = {
      clicked_keyword: innerText,
      isRecentSearchValid,
    }
    segmentSearchItemClicked(searchClickedData)

    sessionStorage.setItem('recent-search-word', innerText)
    setSearchWord(innerText)

    openSearchResults(innerText, openResults)
  }

  return (
    <div className="search-sidebar__item__container">
      {keywordList?.map((item, index) => (
        <button
          className={clsx('search-sidebar__item', Typo.body2)}
          key={item}
          onClick={(e) => searchItem(e)}
        >
          {isRecentSearchValid
            ? item
            : hasLocizeTranslation(t, getKeywordLocizeKey(index), item)}
        </button>
      ))}
    </div>
  )
}

SearchSidebarItem.propTypes = {
  isRecentSearchValid: PropTypes.bool,
  keywordList: PropTypes.arrayOf(PropTypes.string),
  openResults: PropTypes.func.isRequired,
  setSearchWord: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
}

SearchSidebarItem.defaultProps = {
  isRecentSearchValid: false,
  keywordList: [],
}

export default compose(
  connect(null, { openResults: searchModalDuck.creators.openSearchResults }),
  withI18next(),
)(SearchSidebarItem)
